import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { resetPasswordAdmin } from "../../services/authentification/AuthRequest";
import LOGO_MTN2 from "./../../assets/images/logo_momo.jpeg";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [messageAlert, setMessageAlert] = useState("");
  const [succesAlert, setSuccesAlert] = useState("");

  const resetPassword = () => {
    setIsLoading(true);
    setSuccesAlert("");
    setMessageAlert("");
    const data = {
      username: username,
    };

    try {
      resetPasswordAdmin(data)
        .then((res) => {
          setIsLoading(false);
          setSuccesAlert(
            "Vous avez reçu un nouveau mot de passe par email"
          );
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            setMessageAlert(err.response.data.donnee);
          } else {
            setMessageAlert("Une erreur s'est produite, rééssayez!");
          }
          console.log("api error", err);
        });
    } catch (error) {
      setIsLoading(false);
      setMessageAlert("Quelque chose s'est mal passé, rééssayer");
      console.log("catch error", error);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("momo4scoohclient")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="bg-[#f7f7f7] bg-img w-full h-screen flex flex-col items-center justify-center">
      <div>
        <div className="login-form bg-white/90 w-[450px] h-fit rounded-2xl shadow-2xl p-5">
          <div className="my-5">
            <label className="label">
              <span className="label-text">Username</span>
            </label>
            <input
              disabled={isLoading}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              placeholder="exemple@gmail.com"
              className="input input-bordered w-full"
            />
            <button
              disabled={isLoading}
              className="w-full h-11 rounded-lg mt-5 bg-momo-blue text-white font-medium flex items-center justify-center"
              onClick={resetPassword}
            >
              {!isLoading ? (
                <span>Réinitialiser mot de passe</span>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={isLoading}
                />
              )}
            </button>
            {messageAlert ? (
              <div className="mt-5">
                <p className="text-red-500 text-center font-medium">
                  {messageAlert}
                </p>
              </div>
            ) : null}
            {succesAlert ? (
              <div className="mt-5">
                <p className="text-green-500 text-center font-medium">
                  {succesAlert}
                </p>
              </div>
            ) : null}
            <div className="flex justify-center mt-4">
              <Link to="/login" className="underline">
                Se connecter
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
